import './sidebar.css'
import {RssFeed, Bookmark, PlayCircleFilledOutlined, HelpOutline, WorkOutline, Event, School, Chat, } from "@material-ui/icons"
import {Users} from "../../dummydata"
import CloseFriend from '../closeFriends/CloseFriend'




export default function SideBar() {
  return (
    <div className="sideBar">
      <div className="sidebarWrapper">
        <ul className='sidebarList'>
          <li className='sidebarListItem'> 
          <RssFeed className='sidebarIcon'/>
          <span className="sidebarListItemText">Feed</span>
          </li>

          <li className='sidebarListItem'> 
          <Chat className='sidebarIcon'/>
          <span className="sidebarListItemText">Chat</span>
          </li>

          <li className='sidebarListItem'> 
          <PlayCircleFilledOutlined className='sidebarIcon'/>
          <span className="sidebarListItemText">Videos</span>
          </li>

          <li className='sidebarListItem'> 
          <Bookmark className='sidebarIcon'/>
          <span className="sidebarListItemText">Bookmarks</span>
          </li>

          <li className='sidebarListItem'> 
          <HelpOutline className='sidebarIcon'/>
          <span className="sidebarListItemText">Question</span>
          </li>

          <li className='sidebarListItem'> 
          <WorkOutline className='sidebarIcon'/>
          <span className="sidebarListItemText">Job</span>
          </li>

          <li className='sidebarListItem'> 
          <Event className='sidebarIcon'/>
          <span className="sidebarListItemText">Events</span>
          </li>

          <li className='sidebarListItem'> 
          <School className='sidebarIcon'/>
          <span className="sidebarListItemText">Courses</span>
          </li>
        </ul>
        <button className="sidebarButton">Show More</button>
        <hr className='sidebarHr'/>
        <ul className="sidebarFriendList">
          {Users.map(u=>(
            <CloseFriend key={u.id} user={u}/>
          ))}
          
        </ul>
      </div>
    </div>
  )
}
